var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 56,
    rx: 4,
    fill: "#E9E3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0306 23.7194L26.7806 18.4694C26.7109 18.3997 26.6282 18.3445 26.5371 18.3069C26.4461 18.2693 26.3485 18.2499 26.25 18.25H17.25C16.8522 18.25 16.4706 18.408 16.1893 18.6893C15.908 18.9706 15.75 19.3522 15.75 19.75V36.25C15.75 36.6478 15.908 37.0294 16.1893 37.3107C16.4706 37.592 16.8522 37.75 17.25 37.75H30.75C31.1478 37.75 31.5294 37.592 31.8107 37.3107C32.092 37.0294 32.25 36.6478 32.25 36.25V24.25C32.2501 24.1515 32.2307 24.0539 32.1931 23.9629C32.1555 23.8718 32.1003 23.7891 32.0306 23.7194ZM26.25 24.25V20.125L30.375 24.25H26.25Z",
    fill: "#AC96E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.7a6811f0cc87007bddcf3e381d81c4da.svg";
export { ForwardRef as ReactComponent };